import SideMenu from '@/containers/side-menu/SideMenu.vue'
import Welcome from '@/pages/welcome/Welcome.vue'

export default {
  path: '/welcome',
  name: 'Welcome',
  components: {
    mainContent: Welcome,
    mainMenu: SideMenu
  },
  meta: {
    role: {
      sectorId: 'welcome'
    }
  }
}